import React, { useState, useEffect, useRef } from "react";
import PropTypes from "prop-types";
import Drawer from "@mui/joy/Drawer";
import ModalClose from "@mui/joy/ModalClose";
import { Box, Divider, Typography } from "@mui/joy";
import AddressPage from "./pages/AddressPage";
import ContactPage from "./pages/ContactPage";

function FindRepresentative({ open, setOpen }) {
  const [representative, setRepresentative] = useState({});
  const [address, setAddress] = useState("");
  const [page, setPage] = useState("address");
  const previouslyFocusedElement = useRef(null);

  async function findRepresentative(addr) {
    if (addr.length > 0) {
      const rep = await fetch(`/api/member/address/${addr}`).then((r) => r.json());
      setRepresentative(rep);
    }
  }

  useEffect(() => {
    findRepresentative(address);
  }, [address]);

  useEffect(() => {
    if (open) {
      previouslyFocusedElement.current = document.activeElement;
    } else {
      if (previouslyFocusedElement.current) {
        previouslyFocusedElement.current.focus();
      }
      const t = setTimeout(() => {
        setPage("address");
        setRepresentative({});
        setAddress("");
      }, 300);
      return () => clearTimeout(t);
    }
  }, [open]);

  return (
    <Drawer
      anchor="right"
      open={open}
      onClose={() => setOpen(false)}
      slotProps={{
        content: {
          sx: {
            width: { xs: "100%", sm: "480px" },
            display: "flex",
            flexDirection: "column",
            overflow: "hidden",
          },
        },
        backdrop: {
          sx: { backdropFilter: "blur(1px)" },
        },
      }}
    >
      {/* Fixed header */}
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          px: "24px",
          py: "18px",
          flexShrink: 0,
        }}
      >
        <Typography sx={{ fontSize: "18px", fontWeight: 700, color: "#171a1c" }}>
          Find Your Representative
        </Typography>
        <ModalClose
          variant="plain"
          sx={{ position: "relative", top: "auto", right: "auto", "--IconButton-size": "32px" }}
          aria-label="Close"
        />
      </Box>

      <Divider />

      {/* Scrollable content */}
      <Box sx={{ flex: 1, overflowY: "auto", px: "24px", py: "28px" }}>
        {page === "address" ? (
          <AddressPage setOpen={setOpen} setPage={setPage} setAddress={setAddress} />
        ) : (
          <ContactPage setOpen={setOpen} representative={representative} address={address} />
        )}
      </Box>
    </Drawer>
  );
}

FindRepresentative.propTypes = {
  open: PropTypes.bool.isRequired,
  setOpen: PropTypes.func.isRequired,
};

export default FindRepresentative;
